import { Card, Icon, Link, Typography, FlexBox } from "@vp/swan";
import React from "react";

export interface DebugServiceLineItemProps {
  url: string;
}

export const DebugServiceLineItem = (props: DebugServiceLineItemProps) => {
  const { url } = props;
  const path = url?.split("?")?.[0];

  return (
    <Card>
      <Link href={url}>
        <FlexBox>
          <Icon iconType="info" mr={"5"} />
          <Typography fontSize={"xsmall"}>{path}</Typography>
        </FlexBox>
      </Link>
    </Card>
  );
};
